<div style="height: inherit;" *ngIf="isInitalDataLoaded && !isLoadingError">
  <app-litmus-header [showCalendarButton]="true" [showUserButton]="true"></app-litmus-header>
  <!-- <app-side-bar *ngIf="isSideBarEnabled"></app-side-bar> -->
   <app-side-bar-v2 *ngIf="isSideBarEnabled"></app-side-bar-v2>
  <app-ltms-download-widget></app-ltms-download-widget>
  <!-- Placed here global filter side bar popup -->
  <app-ltms-global-filter-side-bar [isAccount]="true"></app-ltms-global-filter-side-bar>
  <div class="main-container" [class.account-list]="isAccountListPage" (scroll)="onScroll()" id="accountRouterOutlet">
    <app-ltms-banner></app-ltms-banner>
    <div class="container-fluid child-container" [class.loading]="!isInitalDataLoaded"  >
      <router-outlet *ngIf="isInitalDataLoaded"></router-outlet>
      <div class="ltms-loading" *ngIf="!isInitalDataLoaded">
        <app-ltms-loader></app-ltms-loader>
      </div>
    </div>
    <app-litmus-footer [isAccount]="isAccountListPage"></app-litmus-footer>
  </div>
</div>
<div class="ltms-loading" *ngIf="!isInitalDataLoaded">
  <app-ltms-loader></app-ltms-loader>
</div>
<div style="height:inherit;" *ngIf="isLoadingError">
  <div class="error-page-container">
    <div class="error-page">
      <div class="error-card">
        <div class="error-card-body">
          <div class="error-icon">
            <h1>:(</h1>
          </div>
          <div class="error-message">
            <span class="error-header">Oops! Something went wrong while fetching the data.</span>
            <span class="error-description">🔄 Please refresh the page and try again.</span>
            <div class="error-card-button-group">
              <button class="home-page-btn" (click)="reloadCurrentPage()">
                🔃 Reload
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
